export const bannerConstants = {
    BANNER_LIST_REQUEST: 'BANNER_LIST_REQUEST',
    BANNER_LIST_SUCCESS: 'BANNER_LIST_SUCCESS',
    BANNER_LIST_ERROR: 'BANNER_LIST_ERROR',
    BANNER_SEARCH_REQUEST : 'BANNER_SEARCH_REQUEST',

    BANNER_ADDED_REQUEST:'BANNER_ADDED_REQUEST',
    BANNER_ADDED_SUCCESS:'BANNER_ADDED_SUCCESS',
    BANNER_ADDED_FAILURE:'BANNER_ADDED_FAILURE',  
        

    BANNER_GET_REQUEST:'BANNER_GET_REQUEST',
    BANNER_GET_SUCCESS:'BANNER_GET_SUCCESS',
    BANNER_GET_FAILURE:'BANNER_GET_FAILURE',
    
    BANNER_BY_ID_REQUEST : 'BANNER_BY_ID_REQUEST',
    BANNER_BY_ID_SUCCESS : 'BANNER_BY_ID_SUCCESS',
    BANNER_BY_ID_FAILURE : 'BANNER_BY_ID_FAILURE',

    BANNER_GET_ACTIVE_REQUEST:'BANNER_GET_ACTIVE_REQUEST',
    BANNER_GET_ACTIVE_SUCCESS:'BANNER_GET_ACTIVE_SUCCESS',
    BANNER_GET_ACTIVE_FAILURE:'BANNER_GET_ACTIVE_FAILURE',

    BANNER_DELETE_REQUEST:'BANNER_DELETE_REQUEST',
    BANNER_DELETE_SUCCESS:'BANNER_DELETE_SUCCESS',
    BANNER_DELETE_FAILURE:'BANNER_DELETE_FAILURE',
};
